import React from "react";
import { useParams } from "react-router-dom";
import DemoHead from "../components/DemoHead";
import SocialLinks from "../components/SocialLinks";

const DemoPage = () => {
  const { id } = useParams();

  return (
    <div>
      <DemoHead id={id} />

      <SocialLinks />
    </div>
  );
};

export default DemoPage;
